module.exports = __webpack_public_path__ + "static/media/pizza.fc972389.jpg";